<template>
  <div class="bg-red-600 text-white p-6 mb-4 text-sm">
    <p class="font-medium">Oops!</p>
    <ul class="mt-2 list-inside list-disc" v-if="errorMessages.length > 1">
      <li v-for="message in errorMessages" :key="message">{{ message }}</li>
    </ul>
    <div class="w-full overflow-auto" v-if="errorMessages.length <= 1" v-html="errorMessages[0]">{{ errorMessages[0] }}</div>
  </div>
</template>

<script>
export default {
  props: {
    errorMessages: {
      type: Array,
    },
  },
};
</script>